<template>
   <!-- Stepper -->
  <div class="d-flex justify-content-start">
    <div class="py-0 px-0" style="border:1px solid gray; border-radius: 20px;">
      <div class="d-flex">
        <div class="ml-4 py-0 d-flex align-items-center">
          <span class="mx-3 my-0">
            <small class="p-1 rounded-circle icon-checkmark bg-primary border-secondary border text-white"></small>
          </span>
              {{$t('lang.orders.your_services')}}
        </div>

        <div class="ml-4  mr-0 py-0">
          <span class="mx-2 my-0  px-0">
              <img src="@/assets/images/arrow-right.png" height="35" alt />
          </span>
          <small v-if="step > 1" class="ml-2  mr-2 p-1 rounded-circle icon-checkmark bg-primary border-secondary border text-white"></small>
          <span class="mx-3" v-else><strong>2</strong></span>
            {{$t('lang.orders.your_target')}}
        </div>

        <div class="mx-5 py-0">
          <span class="mx-2 my-0  px-0">
              <img src="@/assets/images/arrow-right.png" height="35" alt />
          </span>
          <small v-if="step > 2" class="ml-2 mr-2 p-1 rounded-circle icon-checkmark bg-primary border-secondary border text-white"></small>
          <span class="mx-3" v-else><strong>3</strong></span>
            {{$t('lang.orders.summary_title')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Step1Summary from '@/components/Onboarding/MultiSteps/Step1Summary.vue';
export default {
  name: 'Stepper',
  props: {
    step: {
      type: Number,
      default: 1,
      required: true
    }
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped>
</style>
